import { render, staticRenderFns } from "./addPerson.vue?vue&type=template&id=e0662efa&scoped=true"
import script from "./addPerson.vue?vue&type=script&lang=js"
export * from "./addPerson.vue?vue&type=script&lang=js"
import style0 from "./addPerson.vue?vue&type=style&index=0&id=e0662efa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0662efa",
  null
  
)

export default component.exports